import { Grid } from '@mui/material';
import { PostCard } from '../dashboards/PostCard';
import { numberFormat } from '@/utils/number-format';
import { useTranslation } from 'react-i18next';

export type ProfilePreviewProps = {
    profile: {
        picture: string;
        name: string;
        followers: number;
        net: string;
    };
    topPosts: {
        id: string;
        caption: string;
        publishDate: string;
        format: string;
        picture: string;
        url: string;
        likes: number;
        comments: number;
    }[];
};

export const ProfilePreview = (props: ProfilePreviewProps) => {
    const { profile, topPosts } = props;
    const { t } = useTranslation();

    return (
        <Grid container columns={{ xs: 12 }} spacing={2} pb={2}>
            {topPosts.map((post) => (
                <Grid key={post.id} size={{ xs: 12, sm: 6, md: 4 }}>
                    <PostCard
                        post={{
                            profile: {
                                avatar: profile.picture,
                                name: profile.name,
                                net: profile.net,
                            },
                            caption: post.caption,
                            image: post.picture,
                            publishDate: post.publishDate,
                            format: post.format,
                            metrics: [
                                {
                                    name: t('onboarding.profile-preview.likes'),
                                    value: numberFormat(post.likes),
                                },
                                {
                                    name: t('onboarding.profile-preview.comments'),
                                    value: numberFormat(post.comments),
                                },
                            ],
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    );
};
